var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FlaggedQuestionsListComponent } from '../flagged-questions-list/flagged-questions-list.component';
var FlaggedQuestionsListSimpleComponent = /** @class */ (function (_super) {
    __extends(FlaggedQuestionsListSimpleComponent, _super);
    function FlaggedQuestionsListSimpleComponent() {
        var _this = _super.call(this) || this;
        _this.flaggedQuestions = [];
        return _this;
    }
    FlaggedQuestionsListSimpleComponent.prototype.ngOnInit = function () {
        this.flaggedQuestions = this.Assessments.map(function (a) { return a.getFlaggedQuestions(); }).reduce(function (prev, curr) { return curr.concat(prev); }, []);
    };
    FlaggedQuestionsListSimpleComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    Object.defineProperty(FlaggedQuestionsListSimpleComponent.prototype, "FlaggedQuestions", {
        get: function () {
            return this.flaggedQuestions;
        },
        enumerable: true,
        configurable: true
    });
    return FlaggedQuestionsListSimpleComponent;
}(FlaggedQuestionsListComponent));
export { FlaggedQuestionsListSimpleComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.ts.pre-build-optimizer.js